import { type CustomRole, type Member } from '../../../model';

export function shouldShowConsolidationButton(
  member: Member,
  customRoles: { [roleId: string]: CustomRole },
  customRolesWithTeamsForMember: (member: Member, customRoles: { [roleId: string]: CustomRole }) => unknown[],
): boolean {
  const directCustomRoles = member.customRoles || [];
  const teamRoles = customRolesWithTeamsForMember(member, customRoles);
  const hasBuiltInRole = member.role && (member.role as string) !== 'no_access';

  if (directCustomRoles.length === 1 && teamRoles.length === 0) {
    return false;
  }

  if (directCustomRoles.length > 1) {
    return true;
  }

  if (directCustomRoles.length >= 1 && teamRoles.length >= 1) {
    return true;
  }

  if (hasBuiltInRole && teamRoles.length >= 1) {
    return true;
  }

  if (teamRoles.length > 1 && directCustomRoles.length === 0 && !hasBuiltInRole) {
    return true;
  }

  if (teamRoles.length === 1 && directCustomRoles.length === 0 && !hasBuiltInRole) {
    return false;
  }

  return false;
}
